import {
  manifestViewSchema,
  type CoworldDoc,
  type CoworldManifestView,
  type CoworldReporterReference,
  type CoworldRoleKey,
  type CoworldRoleSpec,
} from "./manifest-schema";

type CoworldRequiredDocs =
  | { readonly ok: true; readonly readmeDoc: CoworldDoc }
  | { readonly ok: false; readonly message: string };

export function reporterReferenceLabel(ref: CoworldReporterReference): string {
  return "reporter" in ref ? ref.reporter : `${ref.id} (unsubmitted wasm)`;
}

export function coworldManifest(coworld: {
  readonly manifest: Readonly<Record<string, unknown>>;
}): CoworldManifestView {
  return manifestViewSchema.parse(coworld.manifest);
}

export function roleEntries({
  manifest,
  role,
}: {
  readonly manifest: CoworldManifestView;
  readonly role: CoworldRoleKey;
}): CoworldRoleSpec[] {
  return role === "player" ? manifest.player : (manifest[role] ?? []);
}

export function coworldRequiredDocs(
  manifest: CoworldManifestView,
): CoworldRequiredDocs {
  const readmeDoc = manifest.game.docs?.readme ?? null;

  if (!readmeDoc) {
    return { ok: false, message: "Expected README.md in game.docs.readme" };
  }

  return { ok: true, readmeDoc };
}

export function coworldPlayCommand(coworldId: string): string {
  return `coworld play ${coworldId}`;
}
